module.exports = "/_next/static/images/61cb9ee51ab2a16e8a7b016b2d60fa27-handEmail.svg";